<template>
  <div>
    <MarketPlaceItemInfo v-if="bcomMarketPlaceItem" />
    <div v-else>
      <ul class="margin-left-xs">
        <template v-if="isFreeShippingMessageAvailable && !isShippingReturnsFinalOfferCopy">
          <li
            v-for="(message, index) in freeShippingMessages"
            :key="message"
          >
            <span>
              {{ message }}
              <a
                v-if="index === 0"
                :href="FREE_SHIPPING_LINK"
              > exclusions &amp; details </a>
            </span>
          </li>
        </template>

        <template v-if="!marketPlaceItemEnabled">
          <li
            v-if="surchargeMessage"
            v-html="surchargeMessage"
          />
          <li
            v-if="shippingMessage && !isBigTicketItemFlag"
            v-html="shippingMessage"
          />
          <li
            v-if="specialGiftWrapMessage"
            v-html="specialGiftWrapMessage"
          />
          <li
            v-if="giftWrapMessage && !isBigTicketItemFlag"
            v-html="giftWrapMessage"
          />
        </template>

        <template v-if="isMktPlaceShipMsgsAvailable">
          <li>
            This item qualifies for Free Shipping with minimum purchase!
            <a
              :href="FREE_SHIPPING_LINK"
              data-auto="exclusions-details-link"
            > exclusions &amp; details </a>
          </li>
          <li
            v-for="freeShippingItem in marketPlaceProductShippingMessages"
            :key="freeShippingItem"
            data-testid="free-shipping-item"
            v-html="sanitize(freeShippingItem)"
          />
        </template>

        <li
          v-if="stateRestrictionMessage"
          v-html="stateRestrictionMessage"
        />

        <li
          v-for="note in notes"
          :key="note"
          data-testid="note"
          v-html="sanitize(note)"
        />

        <li
          v-if="isMcom"
        >
          <ShippingAndReturnsPolicyLinks />
        </li>

        <li
          v-if="returnConstraintMessage"
          v-html="returnConstraintMessage"
        />
      </ul>

      <MarketPlaceItemInfo
        v-if="mcomMarketPlaceItem"
        class="margin-top-m"
      />

      <ShippingAndReturnsPolicyLinks
        v-if="!isMcom"
        class="margin-top-s"
      />
    </div>
  </div>
</template>

<script setup>
import { sanitize } from '@vue-util/sanitize';

import { useBrand } from '@composables/useBrand';
import { useFeatureEligibility, useProductFlags } from '@modules/featureControl';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';

import ShippingAndReturnsPolicyLinks from './ShippingAndReturnsPolicyLinks';
import MarketPlaceItemInfo from './MarketPlaceItemInfo';

import { FREE_SHIPPING_LINK } from '../../../constants/common';

const {
  notes,
  freeShippingMessages,
  returnConstraintMessage,
  stateRestrictionMessage,
  shippingMessage,
  specialGiftWrapMessage,
  giftWrapMessage,
  surchargeMessage,
  marketPlaceProductShippingMessages,
} = useCommonProductGetters();
const {
  marketPlaceItemEnabled, isShippingReturnsFinalOfferCopy, isLuxury,
} = useFeatureEligibility();
const { isBigTicketItemFlag } = useProductFlags();
const { isMcom, isBcom } = useBrand();

const isFreeShippingMessageAvailable = isMcom && freeShippingMessages?.value && !marketPlaceItemEnabled && !isBigTicketItemFlag && !isLuxury;
const isMktPlaceShipMsgsAvailable = isMcom && !!marketPlaceProductShippingMessages?.value?.length;
const bcomMarketPlaceItem = isBcom && marketPlaceItemEnabled;
const mcomMarketPlaceItem = isMcom && marketPlaceItemEnabled;
</script>
